import { ReactNode } from "react";
import { AppHeader } from "./AppHeader";
import { BottomNav } from "./BottomNav";
import { Footer } from "./Footer";
import { InstallPWABanner } from "./InstallPWABanner";

export const AppShell = ({ children, title }: { children: ReactNode; title?: string }) => (
  <div className="flex min-h-screen flex-col bg-muted/30 pb-20 md:pb-0">
    <AppHeader title={title} />
    <main className="container max-w-5xl flex-1 px-4 py-6">{children}</main>
    <Footer />
    <BottomNav />
    <InstallPWABanner />
  </div>
);
